import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { ThemeProvider } from "@/components/ThemeProvider";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingActions from "@/components/layout/FloatingActions";
import CartDrawer from "@/components/CartDrawer";
import ChatWidget from "@/components/ChatWidget";
import LaunchAnnouncement from "@/components/LaunchAnnouncement";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Industries from "@/pages/Industries";
import CustomPackaging from "@/pages/CustomPackaging";
import BulkOrders from "@/pages/BulkOrders";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function App() {
  const [showLaunch, setShowLaunch] = useState(true);

  useEffect(() => {
    // Check if user clicked Explore button (app=true in query params)
    const params = new URLSearchParams(window.location.search);
    if (params.get("app") === "true") {
      setShowLaunch(false);
    }
  }, []);

  // Show full-page launch announcement
  if (showLaunch) {
    return (
      <ThemeProvider>
        <LaunchAnnouncement />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <CartProvider>
        <BrowserRouter>
          <SmoothScroll>
            <ScrollToTop />
            <div className="min-h-screen bg-background text-foreground">
              <div className="grain" aria-hidden />
              <Header />
              <main className="relative z-10">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/custom-packaging" element={<CustomPackaging />} />
                  <Route path="/bulk-orders" element={<BulkOrders />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/request-quote" element={<RequestQuote />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/privacy" element={<Legal type="privacy" />} />
                  <Route path="/terms" element={<Legal type="terms" />} />
                </Routes>
              </main>
              <Footer />
              <FloatingActions />
              <CartDrawer />
              {/* <ChatWidget /> */}
            </div>
            <Toaster position="top-right" richColors />
          </SmoothScroll>
        </BrowserRouter>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
